import { useSelector } from "react-redux";
import styled from "styled-components";
import Footer from "./shared/Footer";
import Navbar from "./shared/Navbar";

const ProtectedRoute = ({ children }) => {
  const { user, loading, hasChecked } = useSelector((state) => state.auth);

  if (!hasChecked || loading) {
    return null;
  }

  if (!user) {
    const currentUrl = window.location.href;
    const authUrl = `${process.env.REACT_APP_AUTH_BASE_URL}?redirect=${encodeURIComponent(currentUrl)}`;
    window.location.href = authUrl;
    return null;
  }
  if (!user) {
    window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
    return null;
  }

  return (
    <PageLayout>
      <Navbar />
      <Main>{children}</Main>
      <Footer />
    </PageLayout>
  );
};

export default ProtectedRoute;

const Main = styled.main`
  flex: 1;
  padding-top: 89px;

  @media (max-width: 768px) {
    padding-top: 84px;
  }
`;

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
